import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import ProtectedRoute from './components/ProtectedRoute'
import './scss/style.scss'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

const TestViewAnon = React.lazy(() => import('./features/test/TestViewAnon'))
const TestAttempt = React.lazy(() => import('./features/test/TestAttempt'))
const TestResult = React.lazy(() => import('./features/test/TestResult'))

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route element={<ProtectedRoute />}>
              <Route path="*" name="Тесты" element={<DefaultLayout />} />
            </Route>
            <Route path="/atest/:testId/" name="Тест" element={<TestViewAnon />} />
            <Route path="/a/:attemptId/" name="Прохождение теста" element={<TestAttempt />} />
            <Route path="/ares/:attemptId/" name="Результаты теста" element={<TestResult />} />
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route exact path="/register" name="Register Page" element={<Register />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
          </Routes>
        </Suspense>
      </HashRouter>
    )
  }
}

export default App
